<template>
  <v-row
    dense
    no-gutters
    class="small-book-form pa-0"
  >
    <v-col cols="10" class="pa-0">
      <v-row>
        <v-col
          cols="12"
          md="6"
          class="px-0"
        >
          <SimpleCard>
            <v-row dense no-gutters>
              <v-col cols="12" py-0>
                <h3>User</h3>
              </v-col>
              <v-col cols="8" py-0>
                <ExistingUser
                  :errors="errors.user"
                  :use-existing-user="user.use_existing"
                  @selectedUser="handleSelectedUser"
                  @useExistingUserToggled="useExistingUserToggled"
                />
              </v-col>
              <v-flex
                xs12
                md12
              >
                <UserForm
                  ref="userForm"
                  :disabled="user.use_existing"
                  :user="user"
                  :errors="errors.user"
                  :editing-user="user.use_existing"
                  @validityChange="updateFormValidity('user', $event)"
                />
                <v-divider class="mx-1" />
              </v-flex>
              <v-flex
                xs12
                pl-1
                pt-2
              >
                <h3>Driver</h3>
              </v-flex>
              <v-flex
                xs12
                md12
              >
                <DriverForm
                  ref="driverForm"
                  :driver="driver"
                  :driver-details="driver_details"
                  :errors="driverErrors"
                  @imageInput="handleImageInput"
                  @documentInput="handleDocumentInput"
                  @validityChange="updateFormValidity('driver', $event)"
                />
              </v-flex>
              <v-flex
                xs12
                pl-1
                pt-2
              >
                <h3>Taxi</h3>
              </v-flex>
              <v-flex>
                <ExistingTaxi
                  :errors="errors.taxi"
                  @selectedTaxi="handleSelectedTaxi"
                  @useExistingTaxiToggled="useExistingTaxiToggled"
                />
              </v-flex>
              <v-flex
                xs12
                md12
                class="py-0"
              >
                <TaxiForm
                  ref="taxiForm"
                  :disabled="taxi.use_existing"
                  :taxi="taxi"
                  :errors="errors.taxi"
                  :ride-types="rideTypes"
                  :councils="councils"
                  @validityChange="updateFormValidity('taxi', $event)"
                  @taxiChanged="getVehicleInformation($event)"
                />
              </v-flex>
              <v-flex
                xs12
                md12
              >
                <v-layout
                  align-center
                  justify-end
                >
                  <v-btn
                    color="success"
                    class="text-none"
                    @click="submit"
                  >
                    Submit
                  </v-btn>
                </v-layout>
              </v-flex>
            </v-row>
          </SimpleCard>
        </v-col>
        <v-col
          cols="12"
          md="6"
          class="px-0 pl-1"
        >
          <SimpleCard>
            <v-row dense no-gutters>
              <v-col cols="12" class="text-center">
                <v-flex>
                  <v-avatar color="indigo">
                    <v-icon dark>
                      mdi-account-circle
                    </v-icon>
                  </v-avatar>
                </v-flex>
                <v-flex>
                  <v-btn class="mt-2" @click="pictureDialog = true" small outlined>Upload New</v-btn>
                  <br>
                  <span class="mt-3" v-if="driver.picture">{{driver.picture.name.substring(driver.picture.name.length - 25)}}</span>
                </v-flex>
              </v-col>
              <v-col cols="12">
                <v-divider class="my-4"></v-divider>
              </v-col>
              <v-col cols="12">
                <h3>Documents</h3>
                <DriverDocumentsBox @documentUploaded="updateDocumentFile" :required-documents="documentTypes"></DriverDocumentsBox>
              </v-col>
            </v-row>
          </SimpleCard>
        </v-col>
      </v-row>
    </v-col>
    <v-dialog
      v-model="pictureDialog"
      width="500"
    >
      <v-card class="pa-3">
        <v-card-title class="headline grey lighten-2">
          Uploaded Profile Picture
          <v-spacer></v-spacer>
          <v-icon @click="pictureDialog = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-text>
          <v-layout row class="text-center">
            <v-flex
              px-2
            >
              <FileInput
                label="Photo"
                icon="photo_camera"
                accept="image/*"
                :required="true"
                :error-message="errorForField('picture')"
                :rules="driverRules.picture"
                @fileInput="handleImageInput"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  
    <v-snackbar
      v-model="snackbarShow"
      :color="snackbarColour"
      :timeout="4000"
    >
      {{ snackbarMessage }}
    </v-snackbar>
  </v-row>
</template>

<script>
import SimpleCard from "@/components/widget/SimpleCard.vue";
import UserForm from "@/components/driver/UserFormV2.vue";
import DriverForm from "@/components/driver/DriverFormV2.vue";
import TaxiForm from "@/components/driver/TaxiFormV2.vue";
import ExistingUser from "@/components/driver/ExistingUserV2.vue";
import ExistingTaxi from "@/components/driver/ExistingTaxiV2.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

import moment from "moment";
import DriverDocumentsBox from './DriverNewDocumentsBox'
import FileInput from "@/components/widget/input/FileInput.vue";


export default {
  name: "CreateDriverV2",
  components: {
    FileInput,
    DriverDocumentsBox,
    SimpleCard,
    UserForm,
    DriverForm,
    TaxiForm,
    ExistingUser,
    ExistingTaxi,
  },
  data: function () {
    return {
      pictureDialog: false,
      user: {
        use_existing: true,
        name: "",
        email: "",
        contact_number: "",
        password: "",
        accounting_reference_number: "",
      },
      driver: {
        callsign: "",
        driving_license_number: "",
        hackney_number: "",
        private_hire_number: "",
        driving_license_expiry: "",
        hackney_expiry: "",
        private_hire_expiry: "",
        fee_percentage: "20",
        weekly_charge_amount: "0",
        picture: '',
        documents: [],
        expiryDocuments: [],
      },
      driver_details: {
        address_line_1: "",
        address_line_2: "",
        town: "",
        county: "",
        postcode: "",
        home_phone: "",
        b_tech: false,
        wheelchair_cert: false,
        nvq: false,
        adt: false,
      },
      taxi: {
        use_existing: false,
        registration_number: "",
        plate_number: "",
        make: "",
        model: "",
        colour: "",
        num_seats: 0,
        type: "",
        disabled_access: false,
        premium_vehicle: false,
        pets_allowed: false,
        wide: false,
        hackney_carriage: false,
        mot_valid_until: "",
        insurance_certificate_number: "",
        insurance_valid_until: "",
        compliance_certificate_expiry: "",
        road_tax_valid_until: "",
        council: "",
        ride_type_id: 0,
        taxStatus: "",
        motStatus: "",
        ves_mot_valid_until: "",
        ves_road_tax_valid_until: "",
      },
      rideTypes: [],
      councils: [],
      errors: {},
      userFormValid: false,
      taxiFormValid: false,
      driverFormValid: false,
      snackbarShow: false,
      snackbarMessage: null,
      snackbarColour: null,
      driverApplication: null,
      driverRules: {
        driving_license_number: [],
        callsign: [
          (v) =>
            !v ||
            (v.length > 0 && v.length < 6) ||
            "Callsign must not exceed 6 digits",
        ],
        hackney_number: [
          (v) =>
            !v ||
            (v.length >= 1 && v.length <= 6) ||
            "Hackney carriage number must be from 3 to 6 digits",
        ],
        private_hire_number: [
          (v) =>
            !v ||
            (v.length >= 1 && v.length <= 6) ||
            "Private hire number must be from 3 to 6 digits",
        ],
        driving_license_expiry: [
          (v) =>
            !v ||
            /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/.test(v) ||
            "Driving license expiry is in an invalid format",
        ],
        hackney_expiry: [],
        private_hire_expiry: [],
        fee_percentage: [
          (v) =>
            !v ||
            (v && parseInt(v) >= 0 && parseInt(v) <= 100) ||
            "Commission Percentage must be between 0 and 100",
        ],
        weekly_charge_amount: [
          (v) =>
            (v && parseInt(v) >= 0 && parseInt(v) <= 1000000) ||
            "Weekly charge amount must be between 0 or more",
        ],
        picture: [],
        documentDescription: [(v) => !!v || "Document description is required"],
      },
      documentTypes: [
        {
          name: 'DVLA Drivers badge (front & back)',
          expiryDate: '',
          file: "",
          type: 'dvla_license'
        },
        {
          name: 'Council Compliance Certificate',
          expiryDate: '',
          file: "",
          type: 'compliance_certificate'
        },
        {
          name: 'Vehicle Insurance',
          expiryDate: '',
          file: "",
          type: 'insurance'
        },
        {
          name: 'Proof of address',
          expiryDate: '',
          file: "",
          type: 'proof_of_address'
        },
        {
          name: 'Vehicle Plate',
          expiryDate: '',
          file: "",
          type: 'vehicle_plate'
        },
        {
          name: 'Hackney Carriage or Private Hire Badge',
          expiryDate: '',
          file: "",
          type: 'hackney_license'
        },
        {
          name: 'MOT Certificate',
          expiryDate: '',
          file: "",
          type: 'mot'
        },
        {
          name: 'Operators License',
          expiryDate: '',
          file: "",
          type: 'operators_license'
        },
        {
          name: 'Public Liability Insurance',
          expiryDate: '',
          file: "",
          type: 'public_liability_insurance'
        },
        {
          name: 'Employers Liability Insurance',
          expiryDate: '',
          file: "",
          type: 'employers_liability_insurance'
        },
        {
          name: 'Private Hire License Number',
          expiryDate: '',
          file: "",
          type: 'private_hire_license'
        },
        {
          name: 'Road Tax',
          expiryDate: '',
          file: "",
          type: 'road_tax'
        },
        {
          name: 'Form B',
          expiryDate: '',
          file: "",
          type: 'form_b'
        },
        {
          name: 'DBS',
          expiryDate: '',
          file: "",
          type: 'dbs'
        }
  
      ],
    };
  },
  watch: {
    driver: {
      handler: function () {
        if (this.driver.driving_license_expiry) {
          this.updateRequiredDocumentsExpiryDate("dvla_license", this.driver.driving_license_expiry)
        }
        if (this.driver.hackney_expiry) {
          this.updateRequiredDocumentsExpiryDate("hackney_license", this.driver.hackney_expiry)
        }
        if (this.driver.private_hire_expiry) {
          this.updateRequiredDocumentsExpiryDate("private_hire_license", this.driver.private_hire_expiry)
        }
      },
      deep: true,
    },
    taxi: {
      handler: function () {
        if (this.taxi.mot_valid_until) {
          this.updateRequiredDocumentsExpiryDate("mot", this.taxi.mot_valid_until)
        }
        if (this.taxi.road_tax_valid_until) {
          this.updateRequiredDocumentsExpiryDate("road_tax", this.taxi.road_tax_valid_until)
        }
        if (this.taxi.compliance_certificate_expiry) {
          this.updateRequiredDocumentsExpiryDate("compliance_certificate", this.taxi.compliance_certificate_expiry)
        }
        if (this.taxi.insurance_valid_until) {
          this.updateRequiredDocumentsExpiryDate("insurance", this.taxi.insurance_valid_until)
        }
      },
      deep: true,
    },
  },
  computed: {
    driverErrors: function () {
      return {
        ...this.errors.driver,
        ...this.errors.driver_details,
      };
    },
  },
  mounted: function () {
    this.getTaxiInformation();

    var vm = this;

    console.log(this.$route.query.driverApplicationUserId);

    if (this.$route.query.driverApplicationUserId != null) {
      var applicantID = this.$route.query.driverApplicationUserId;
      this.getDriverApplication(applicantID);
    } else {
      this.user.use_existing = false;
    }
  },
  methods: {
    errorForField: function (field) {
      try {
        return this.errors[field];
      } catch (err) {
        return null;
      }
    },
    prepareDriverExpiryDocuments () {
      this.documentTypes.forEach(doc => {
        if (doc.file) {
          this.driver.expiryDocuments.push(doc)
        }
      })
    },
    updateRequiredDocumentsExpiryDate(type, expiryDate) {
      let document = this.documentTypes.find(doc => {
        return doc.type == type
      })
      if (document) {
        document.expiryDate = expiryDate
      }
    },
    updateDocumentFile(data) {
      console.log('data for file', data)
      let document = this.documentTypes.find(doc => {
        return doc.type == data.type
      })
      if (document) {
        document.file = data.file
        document.expiryDate = data.expiryDate
      }
    },
    formatDate(date) {
      var date = moment(date).format("YYYY-MM-DD");

      if (date == "Invalid Date") {
        return "";
      }
    },
    populateFormFromApplication() {
      var da = this.driverApplication;
      var dd = da.driverSignupDetails;
      var ti = da.taxiSignupInformation;
      var u = da.user;

      //       user: {
      //   use_existing: false,
      //   name: "",
      //   email: "",
      //   contact_number: "",
      //   password: "",
      //   accounting_reference_number: ""
      // },

      this.user.id = u.id;
      this.user.name = u.name;
      this.user.email = u.email;
      this.user.contact_number = u.contactNumber;

      console.log(this.user);

      this.driver.driving_license_number = dd.licenceNumber;
      this.driver.hackney_number = dd.hackneyNumber;
      this.driver.private_hire_number = dd.hireNumber;
      this.driver.driving_license_expiry = this.formatDate(
        dd.licenceRenewalDate
      );
      this.driver.hackney_expiry = this.formatDate(dd.hackneyNumberRenewalDate);
      this.driver.private_hire_expiry = this.formatDate(
        dd.hireNumberRenewalDate
      );

      this.driver_details.address_line_1 = dd.address1;
      this.driver_details.address_line_2 = dd.address2;
      this.driver_details.town = dd.town;
      this.driver_details.county = dd.county;
      this.driver_details.postcode = dd.postcode;
      this.driver_details.home_phone = dd.homeNumber;

      this.driver_details.b_tech = dd.btech;
      this.driver_details.wheelchair_cert = dd.wheelChairCertificate;
      this.driver_details.nvq = dd.nvq;
      this.driver_details.adt = dd.adt;

      this.taxi.registration_number = ti.registrationNumber;
      this.taxi.plate_number = ti.plateNumber;
      this.taxi.make = ti.make;
      this.taxi.model = ti.model;
      this.taxi.colour = ti.colour;
      this.taxi.num_seats = ti.numSeats;
      this.taxi.disabled_access = ti.disabledAccess;
      this.taxi.premium_vehicle = ti.premiumVehicle;
      this.taxi.pets_allowed = ti.petsAllowed;
      this.taxi.wide = ti.wide;
      this.taxi.hackney_carriage = ti.wide;
      this.taxi.insurance_certificate_number = ti.insuranceCertificateNumber;
      this.taxi.mot_valid_until = this.formatDate(ti.motValidUntil);
      this.taxi.insurance_valid_until = this.formatDate(ti.insuranceValidUntil);
      this.taxi.compliance_certificate_expiry = this.formatDate(
        ti.complianceCertificateExpiry
      );
      this.taxi.road_tax_valid_until = this.formatDate(ti.roadTaxValidUntil);
      this.taxi.council = ti.council;
      this.taxi.type = ti.type;
    },
    getDriverApplication: async function (applicantID) {
      this.loading = true;

      let self = this;

      try {
        var url = `${this.$store.state.apiUrl}/driver_signup/${applicantID}/get`;

        let response = await axios.get(url, {
          params: {},
        });

        this.driverApplication = response.data;
        this.populateFormFromApplication();

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get driver application " + error);
      }
    },
    getTaxiInformation: async function () {
      try {
        let url = `${this.$store.state.apiUrl}/taxi/getCouncilAndRideTypesForCreateTaxi`;
        let response = await axios.get(url, {
          params: {},
        });
        this.rideTypes = response.data.ride_types;
        this.councils = response.data.councils;
      } catch (error) {
        console.log(
          "Failed to get information required to create taxi " + error
        );
      }
    },
    submit: async function () {
      if (this.userFormValid && this.taxiFormValid && this.driverFormValid) {
        this.prepareDriverExpiryDocuments()
        let self = this;
        let url = `${this.$store.state.apiUrl}/driver/create`;
        axios({
          url: url,
          method: "post",
          data: {
            user: this.user,
            driver: this.driver,
            driver_details: this.driver_details,
            taxi: this.taxi,
          },
          headers: {
            "Content-Type": "text/plain",
          },
        })
          .then(function (response) {
            console.log(response.data.errors);
            if (response.data.errors) {
              self.errors = response.data.errors;
              self.snackbarMessage =
                "Error adding driver, please check the form";
              self.snackbarColour = "error";
              self.snackbarShow = true;
            } else if (response.data.error != "no_error") {
              self.snackbarMessage =
                "Error adding driver: " + response.data.error;
              self.snackbarColour = "error";
              self.snackbarShow = true;
              console.log(response.data.error);
            } else {
              const driverID = response.data.driver.id;
              self.$router.push("/drivers/" + driverID);
            }
          })
          .catch(function (error) {
            console.log(error);
            self.snackbarMessage = "Network error: " + error;
            self.snackbarColour = "error";
            self.snackbarShow = true;
          });
      } else {
        this.snackbarMessage = "Please complete the form before submitting";
        this.snackbarColour = "error";
        this.snackbarShow = true;
        this.$refs.userForm.validateForm();
        this.$refs.driverForm.validateForm();
        this.$refs.taxiForm.validateForm();
      }
    },
    handleImageInput: function (file) {
      this.driver.picture = file;
      this.pictureDialog = false
    },
    handleDocumentInput: function (files) {
      this.driver.documents = files;
    },
    handleSelectedUser: function (existingUser) {
      console.log("Selected User");

      this.user.id = existingUser.id;
      this.user.name = existingUser.name;
      this.user.email = existingUser.email;
      this.user.contact_number = existingUser.contact_number;
    },
    useExistingUserToggled: function (useExisting) {
      this.user.use_existing = useExisting;
    },
    handleSelectedTaxi: function (existingTaxi) {
      this.taxi.registration_number = existingTaxi.registration_number;
      this.taxi.plate_number = existingTaxi.plate_number;
      this.taxi.make = existingTaxi.make;
      this.taxi.model = existingTaxi.model;
      this.taxi.colour = existingTaxi.colour;
      this.taxi.council = existingTaxi.council;
      this.taxi.num_seats = existingTaxi.num_seats;
      this.taxi.type = existingTaxi.type;
      this.taxi.disabled_access = existingTaxi.disabled_access;
      this.taxi.premium_vehicle = existingTaxi.premium_vehicle;
      this.taxi.pets_allowed = existingTaxi.pets_allowed;
      this.taxi.wide = existingTaxi.wide;
      this.taxi.hackney_carriage = existingTaxi.hackney_carriage;
      this.taxi.mot_valid_until = existingTaxi.mot_valid_until;
      this.taxi.insurance_certificate_number =
        existingTaxi.insurance_certificate_number;
      this.taxi.insurance_valid_until = existingTaxi.insurance_valid_until;
      this.taxi.compliance_certificate_expiry =
        existingTaxi.compliance_certificate_expiry;
      this.taxi.road_tax_valid_until = existingTaxi.road_tax_valid_until;
      this.taxi.council = existingTaxi.council;
      this.taxi.ride_type_id = existingTaxi.ride_type_id;
    },
    useExistingTaxiToggled: function (useExisting) {
      this.taxi.use_existing = useExisting;
    },
    updateFormValidity: function (form, value) {
      switch (form) {
        case "user":
          this.userFormValid = value;
          break;
        case "driver":
          this.driverFormValid = value;
          break;
        case "taxi":
          this.taxiFormValid = value;
          break;
      }
    },
    getVehicleInformation: async function (regNumber) {
      console.log("Getting vehicle information");
      console.log("New RegNumber: ", regNumber);

      this.loading = true;

      let self = this;

      try {
        var url = `${this.$store.state.apiUrl}/taxi/${regNumber}/info`;

        let response = await axios.get(url, {
          params: {},
        });

        let vehicleInfo = response.data.vehicle_information;

        this.taxi.make = vehicleInfo.make;
        this.taxi.model = vehicleInfo.model;
        this.taxi.colour = vehicleInfo.colour;

        this.taxi.euroStatus = vehicleInfo.euroStatus;
        this.taxi.fuelType = vehicleInfo.fuelType;

        this.taxi.taxStatus = vehicleInfo.taxStatus;
        this.taxi.motStatus = vehicleInfo.motStatus;

        this.taxi.ves_road_tax_valid_until = vehicleInfo.taxDueDate;
        this.taxi.ves_mot_valid_until = vehicleInfo.motExpiryDate;

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get driver application " + error);
      }
    }
  },
};
</script>